<template>
  <div id="main-content">
    <PanelCard :home-show-data="homeShowData"></PanelCard>
    <a-card title="日级汇总"
      style="width: 100%;flex: 1;overflow-y: hidden;border-radius: 5px;"
      :bodyStyle="{padding:'0',height: 'calc(100% - 65px)'}">
      <div slot="extra">
        <a-select v-model="product" style="width: 240px" allowClear showSearch
                  :maxTagCount="1" placeholder="请选择产品"
                  optionFilterProp="label"
                  @change="changeDate()">
          <a-select-option v-for="productItem in $store.getters.getAppAll"
                           :label="productItem.app_name"
                           :value="productItem.app_id"
                           :key="productItem.app_id">
            <img :src="productItem.icon" style="height: 28px;border-radius: 5px;">
            {{productItem.app_name}}
          </a-select-option>
        </a-select>
        <a-range-picker v-model="date"
                        valueFormat="YYYY-MM-DD"
                        style="width: 240px;" @change="changeDate()" />
        <a-button type="primary">导出</a-button>
      </div>
      <a-table :columns="getTableColumns" id="show-table"
               style="height: 100%;overflow-y: hidden;background: #ffffff"
               :scroll="{ x: '500px',y: _get_table_scroll({id:'show-table'}) }"
               :data-source="tableData"
               :rowKey="item=>item.date" :loading="tableLoad"
               bordered :pagination="false">
        <template slot="roi" slot-scope="text">
          <span :style="{color: text===100?'#3f8600':text<100?'#cf1322':'#1890ff'}">{{ text }} %</span>
        </template>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import PanelCard from "../../components/V1/PanelCard";
import {GetHomeSummary, GetHomeSummaryDate} from "../../api/v1/home_api";
export default {
  name: "Index",
  components: {PanelCard},
  data(){
    return {
      date:['',''],
      product:'',
      homeShowData:[],
      tableData:[],
      tableLoad:false,
    }
  },
  mounted() {
    // this.init_data()
  },
  computed: {
    getTableColumns(){
      let _table_columns = [
        {
          title: '日期',
          dataIndex: 'date',
          scopedSlots: { customRender: 'date' }
        },
        {
          title: '花费',
          dataIndex: 'spend',
        },
        {
          title: '收益(广告)',
          dataIndex: 'revenue'
        },
        {
          title: 'ROI',
          dataIndex: 'roi',
          scopedSlots: { customRender: 'roi' }
        },
        // {
        //   title: '毛利',
        //   dataIndex: 'net',
        //   scopedSlots: { customRender: 'net' }
        // }
      ]
      return _table_columns
    }
  },
  methods :{
    init_data(){
      GetHomeSummary({}).then(resp => {
        if (resp.code===200){
          this.homeShowData = resp.data
          this.init_table_list()
        }
      })
    },
    init_table_list(){
      if (this.tableLoad) return
      this.tableLoad = true
      GetHomeSummaryDate({start:this.date[0],end:this.date[1],app_id:this.product}).then(resp => {
        this.tableLoad = false
        if (resp.code==200){
          this.date = resp.data.date
          this.tableData = resp.data.list
        }
      })
    },
    changeDate(){
      this.init_table_list()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Home/Index.vue